import axios from "axios"

export const axiosInstance = axios.create({ 
  baseURL: process.env.REACT_APP_BASE_URL || "http://localhost:4000/api/v1",
})

export const apiConnector = (method, url, bodyData, headers, params) => {
  return axiosInstance({
    method: method,
    url: url,
    data: bodyData ? bodyData : null,
    headers: headers ? headers : {},
    params: params ? params : {},
  })
}
